<!-- MOLECULE: AccountMenuCardSignOut.vue -->

<script setup lang="ts">
//
// Initial Setup
//

// Localization
const { t } = useI18n();

//
// Props
//
defineProps<{ logout: () => void }>();
</script>

<template>
  <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
    <template #activator="{ props: tooltipProps }">
      <v-hover>
        <template #default="{ isHovering, props: hoverProps }">
          <div
            v-bind="tooltipProps"
            class="text-caption px-8 d-flex align-center ga-2 py-1 cursor-pointer"
            :class="{ 'bg-hover': isHovering }"
            @click="logout"
            @mouseenter="hoverProps.onMouseenter as (payload: MouseEvent) => void"
            @mouseleave="hoverProps.onMouseleave as (payload: MouseEvent) => void"
          >
            <v-icon icon="mdi-login-variant" size="small" />
            <span>
              {{
                t(
                  "components.common.app-bar.app_bar_actions.account_menu.account_menu_card.sign_out.title",
                )
              }}
            </span>
          </div>
        </template>
      </v-hover>
    </template>

    <span>
      {{
        t(
          "components.common.app-bar.app_bar_actions.account_menu.account_menu_card.sign_out.tooltip",
        )
      }}
    </span>
  </v-tooltip>
</template>

<style scoped>
.bg-hover {
  background-color: #f6f6f6 !important;
}
</style>
